import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from "contentful";

/**
 * Fields type definition for content type 'TypeProcessStep'
 * @name TypeProcessStepFields
 * @type {TypeProcessStepFields}
 * @memberof TypeProcessStep
 */
export interface TypeProcessStepFields {
    /**
     * Field type definition for field 'internalTitle' (Internal Title)
     * @name Internal Title
     * @localized false
     */
    internalTitle?: EntryFieldTypes.Symbol;
    /**
     * Field type definition for field 'header' (Header)
     * @name Header
     * @localized true
     */
    header: EntryFieldTypes.Symbol;
    /**
     * Field type definition for field 'description' (Description)
     * @name Description
     * @localized true
     */
    description: EntryFieldTypes.Text;
    /**
     * Field type definition for field 'icon' (Icon)
     * @name Icon
     * @localized false
     */
    icon?: EntryFieldTypes.Symbol;
}

/**
 * Entry skeleton type definition for content type 'processStep' (Process Step)
 * @name TypeProcessStepSkeleton
 * @type {TypeProcessStepSkeleton}
 * @author 7BjsgI9gzpO6Dv7BH5AOT6
 * @since 2018-03-28T13:17:12.990Z
 * @version 20
 */
export type TypeProcessStepSkeleton = EntrySkeletonType<TypeProcessStepFields, "processStep">;
/**
 * Entry type definition for content type 'processStep' (Process Step)
 * @name TypeProcessStep
 * @type {TypeProcessStep}
 * @author 7BjsgI9gzpO6Dv7BH5AOT6
 * @since 2018-03-28T13:17:12.990Z
 * @version 20
 */
export type TypeProcessStep<Modifiers extends ChainModifiers, Locales extends LocaleCode = LocaleCode> = Entry<TypeProcessStepSkeleton, Modifiers, Locales>;

export function isTypeProcessStep<Modifiers extends ChainModifiers, Locales extends LocaleCode>(entry: Entry<EntrySkeletonType, Modifiers, Locales>): entry is TypeProcessStep<Modifiers, Locales> {
    return entry.sys.contentType.sys.id === 'processStep'
}
